import { Injectable } from '@angular/core';
import { BaseService } from '../../shared/service/base.service';
import { Observable } from 'rxjs';
///
// import { Injectable } from '@angular/core';
// import { BaseService } from '../../shared/service/base.service';
// import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class SubscriptionPackagesAdminService {
  subscriptionPackageEndPoint = 'api/v1/subscription-package';
  constructor(
    private baseService: BaseService
  ) { }

  filterSubscriptionPackages(requestBody) {
    return this.baseService.post(requestBody, 'api/v1/subscription-package/filter')
  }

  // filterCustomerSubscriptionPackages(countryId) {
  //   return this.baseService.get(`api/v1/subscription-package/index/list-By-country?countryId=${countryId}`)
  //   // return this.baseService.get(`api/v1/subscription-package/list-by-country?countryId=${countryId}`)
  // }
  

  filterCustomerSubscriptionPackages(countryId): Observable<any> {
    return this.baseService.getPublic(
      `api/v1/subscription-package/index/list-By-country?countryId=${countryId}`
    );
  }

  getSubscriptionPackagesRequestsCount() {
    return this.baseService.get(`api/v1/dashboard/draft-subscription-request-count`)
  }

  getSubscriptionPackagesRequests(query) {
    return this.baseService.post(query, 'api/v1/subscription-request/filter')
  }
  getCustomerSubscriptionPackagesRequests() {
    return this.baseService.get('api/v1/subscription-request/customer')
  }
  updateRequestPrivilege(requestId) {
    return this.baseService.put({}, `api/v1/subscription-request/update-privilege?requestId=${requestId}`)
  }
  getUserPrivileges() {
    return this.baseService.get('api/v1/auth/user-privilege')
  }



  updateSubscriptionPackagesRequestStatus(id, statusCode) {
    return this.baseService.post({
      "id": id,
      "statusCode": statusCode
    }, 'api/v1/subscription-request/approve')
  }

  insertSubscriptionPackages(requestBody) {
    return this.baseService.post(requestBody, 'api/v1/subscription-package')
  }



  updateSubscriptionPackages(requestBody) {
    return this.baseService.put(requestBody, 'api/v1/subscription-package')
  }

  deleteSubscriptionPackages(id) {
    return this.baseService.deleteById(`api/v1/subscription-package?id=${id}`)
  }

  get(): Observable<any> {
    return this.baseService.get(`${this.subscriptionPackageEndPoint}/page?sortableColumn=id`);
  }

  callGoogleTranslateApi(text, source, target): any {
    return this.baseService.callGoogleTranslateApi(text, source, target);
  }

  getPackagePrivilege(packageId) {
    return this.baseService.get(
      `${this.subscriptionPackageEndPoint}/get-package-privilege?packagId=${packageId}`
    );
  }
  setPackagePrivilege(packageId, packagePrivileges) {
    return this.baseService.post(
      packagePrivileges,
      `${this.subscriptionPackageEndPoint}/give-package-privilege?packageId=${packageId}`
    );
  }

  getPackageById(id) {
    return this.baseService.get(`${this.subscriptionPackageEndPoint}/${id}`);
  }

  // updateCustomerPackage(packagesIds,periodId){
  //   console.log(packagesIds);
  //  return  this.baseService.put({},`api/v1/customer/update-package?packageIds=${packagesIds}&periodId=${periodId}`)
  // }
  updateCustomerPackage(packageData, periodId) {
    return this.baseService.put(packageData, `api/v1/customer/update-package?notes=&periodId=${periodId}`);
  }

  requestPackageQuotation(requestData: any) {
    return this.baseService.post(requestData, `api/v1/email/package-quotation`);
  }
  // updateCustomerPackage(packageData, periodId, packageIds?) {
  //   // If packageIds is provided, include it in the request body
  //   const requestBody = { ...packageData };
  //   if (packageIds) {
  //     requestBody.packageIds = packageIds;
  //   }

  //   return this.baseService.put(requestBody, `api/v1/customer/update-package?notes=&periodId=${periodId}`);
  // }

  // New method to get customer information by ID
  getCustomerById(customerId: string) {
    return this.baseService.get(`api/v1/customer/${customerId}`);
  }

  // New method to get list of customers for admin selection
  getCustomersList() {
    return this.baseService.get('api/v1/customer/list');
  }

  // New method for admin to update a customer's package
  updateCustomerPackageByAdmin(requestBody, periodId, customerId) {
    return this.baseService.post(requestBody, `api/v1/subscription-request/admin?periodId=${periodId}&customerId=${customerId}`);
  }
}


